import { Typography } from "@mui/material";

import { TextProps } from "./type";
const Text = (props: TextProps) => {
  const {
    children,
    className,
    color = "black",
    lineHeight = "24px",
    size = "16px",
    type = "Regular",
    talk = "",
    textAlign,
    width = "auto",
    display = "unset",
  } = props;
  return (
    <Typography
      sx={{ display: display }}
      width={width}
      className={className}
      color={color}
      lineHeight={lineHeight}
      fontSize={size}
      fontFamily={[`KrungthaiFast-${type}`].join(",")}
      aria-label={talk || (children as string)}
      textAlign={textAlign}
    >
      {children}
    </Typography>
  );
};
export default Text;
